import React from "react";

import { Container } from "react-bootstrap";

import DocumentComponent, {
  CANONICAL_ORIGIN,
} from "@/components/Document.component";
import { release20260508En } from "@/data/releases/2026-05-08-en.html";
import { release20260508Fr } from "@/data/releases/2026-05-08-fr.html";

import i18n from "../../i18n";

const Release20260508 = (): React.JSX.Element => {
  const { t, language } = i18n;

  const title = t(
    "Canadian Home Solution Builder Partners With National Foundation to Address Indigenous Housing Crisis",
  );
  const description = t(
    "PakVille and The Steven Low Foundation combine sustainable housing innovation with community-informed guidance to help deliver scalable, culturally respectful housing solutions for Indigenous communities across Canada.",
  );
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: title,
    description,
    datePublished: "2026-05-08",
    inLanguage: language,
    author: { "@type": "Organization", name: "PakVille™" },
    publisher: {
      "@type": "Organization",
      name: "PakVille™",
      url: CANONICAL_ORIGIN,
      logo: {
        "@type": "ImageObject",
        url: `${CANONICAL_ORIGIN}/images/logo/pakville.png`,
      },
    },
  };

  return (
    <React.Fragment>
      <DocumentComponent
        description={description}
        jsonLd={jsonLd}
        title={title}
      />
      <Container as="article" className="pressRelease my-5">
        <div
          dangerouslySetInnerHTML={{
            __html: language === "fr" ? release20260508Fr : release20260508En,
          }}
        />
      </Container>
    </React.Fragment>
  );
};

export default Release20260508;
